window.CredentialNS = {
    MODES: {
        EDIT_MODAL:'EDIT_MODAL'
    },
    getCredentialInfo: function(container){
        var
            credentialTypeId = $(container).data('type'),
            info = {credential_type_id: credentialTypeId, defined: true},
            fields = [];

        // Get fields
        $(container).find('[role=credential-field]').map(function(index, elem){
            fields.push({
                name:$(elem).attr('name'),
                value:$(elem).val()
            });
        });

        // Get hidden fields
        $(container).find('[role=credential-hidden-field]').map(function(index, elem){
            fields.push({
                name:$(elem).attr('name'),
                value:$(elem).val()
            });
        });

        var attachs = '';
        if ($(container).closest('#credential-main-ct').find('[role=attachments-container]').is(':visible')){
            attachs = $(container).closest('#credential-main-ct').find('[role=attachments-container]').FileUploadHelper('getDocuments').join(',');
        }

        fields.push({
            name: 'attachments',
            value: attachs
        });

        fields.push({
            name: 'attachments_origin_type',
            value: globalConstants.ORIGIN_TYPE_CREDENTIAL
        });

        // Collect info
        $.each(fields, function(index, field){
            info[field.name] = field.value;
        });

        return info;
    },

    clearInfo: function(container){
        $(container).find('[role=credential-label]').removeClass('form_label_mandatory');
        $(container).find('[role=credential-field]').removeClass('form_field_mandatory error').val(null);
        //$(container).closest('#credential-main-ct').find('[role=attachments-container]').FileUploadHelper(''); //Remove current attached files
        $(container).closest('#credential-main-ct').find('#credential-attachements-ct').hide();
    },

    updateStatus: function(evt, data){
        var
            container = $(evt.target),
            flgMandatory = data.flgMandatory;

        debug.log('CredencialNS updateStatus', data);

        $(container).closest('#credential-main-ct').find('#credential-attachements-ct').show();

        if(flgMandatory){
            $(container).find('[role=credential-label]').addClass('form_label_mandatory');
            $(container).find('[role=credential-field]').addClass('form_field_mandatory');
        } else {
            $(container).find('[role=credential-label]').removeClass('form_label_mandatory');
            $(container).find('[role=credential-field]').removeClass('form_field_mandatory error');
        }
    },

    editCredential: function(credentialId, callback, params){
        // Open modal
        Hades.showLoading();
        var _params = params;
        if (!_params) {
            _params = {credential_id:credentialId};
        } else{
            _params.credential_id = credentialId;
        }

        $.get('/credential/edit_credential_modal', _params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                $('#edit-credential-modal-ct').bind('windowClosed', function(evt, data){
                    $.fancybox.close();

                    if(callback){
                        callback(data);
                    }
                });

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });
    },

    setMode: function(container, mode){
        if(mode = CredentialNS.MODES.EDIT_MODAL){
            // Hide fields
            $(container).find('div.form_elem:not([mode=EDIT_MODAL])').hide();
        } else {
            $(container).find('div.form_elem').show();
        }
    }
};